"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
const appearOnGivenPage_1 = require("./appearOnGivenPage");
const Footer = ({ pageNumberAlignment, transformValue, styles: footerStyles, blackListedPages = [], }) => {
    const styles = rpdf_renderer_1.StyleSheet.create({
        text: {
            fontFamily: footerStyles === null || footerStyles === void 0 ? void 0 : footerStyles.fontFamily,
            fontSize: footerStyles === null || footerStyles === void 0 ? void 0 : footerStyles.fontSize,
        },
        container: {
            display: 'flex',
            flexDirection: 'row',
            alignSelf: 'auto',
            justifyContent: 'space-between',
            alignItems: 'stretch',
            alignContent: 'stretch',
            minHeight: footerStyles === null || footerStyles === void 0 ? void 0 : footerStyles.minHeight,
        },
    });
    return (jsx_runtime_1.jsxs(rpdf_renderer_1.View, Object.assign({ style: styles.container }, { children: [jsx_runtime_1.jsx(rpdf_renderer_1.Text, { style: [styles.text], render: ({ pageNumber, subPageNumber }) => {
                    if (pageNumberAlignment === 'center') {
                        return '';
                    }
                    return appearOnGivenPage_1.appearOnGivenPage('even', transformValue(pageNumber), pageNumber, subPageNumber, blackListedPages);
                } }, void 0), jsx_runtime_1.jsx(rpdf_renderer_1.Text, { style: [styles.text], render: ({ pageNumber, subPageNumber }) => {
                    if (pageNumberAlignment === 'outside') {
                        return '';
                    }
                    return appearOnGivenPage_1.appearOnGivenPage('all', transformValue(pageNumber), pageNumber, subPageNumber, blackListedPages);
                } }, void 0), jsx_runtime_1.jsx(rpdf_renderer_1.Text, { style: [styles.text], render: ({ pageNumber, subPageNumber }) => {
                    if (pageNumberAlignment === 'center') {
                        return '';
                    }
                    return appearOnGivenPage_1.appearOnGivenPage('odd', transformValue(pageNumber), pageNumber, subPageNumber, blackListedPages);
                } }, void 0)] }), void 0));
};
exports.default = Footer;
//# sourceMappingURL=footer.js.map